const defaultTitle = "红塔仁恒车辆预约系统";
const defaultMeta = {
  // 当前路由对应title
  title: defaultTitle,
  // 是否缓存页面
  keepAlive: false,
  // 是否显示底部Copyright
  showFoot: false,
  // 是否显示左菜单
  showLeftAside: false,
  // 权限显示
  powerList: [],
  // 对应菜单名字
  menuName: ""
};
console.log(defaultMeta);
// 解决权限问题
// 解决激活刷新问题
// 解决菜单分组问题 ok
// 每个页面都都左边菜单配置，方便统计管理，以及整体布局的调整以及优化 ok
const routes = [
  {
    path: "/nhqy",
    redirect: "/nhqy/loginAccout"
  },
  {
    path: "/nhqy/login",
    name: "nhqyLogin",
    component: () => import("../Login.vue")
  },
  {
    path: "/nhqy/loginAccout",
    name: "nhqyloginAccout",
    component: () => import("../LoginAccout.vue")
  },
  {
    path: "/nhqy/loginAccoutTest",
    name: "nhqyloginAccoutTest",
    component: () => import("../LoginAccoutTest.vue")
  },
];
export default routes;
